import { Component, Input, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import Chart from 'chart.js/auto';
import { DaysOfWeekSelectorComponent } from "../../days-of-week-selector/days-of-week-selector.component";
import { DeviceService } from 'src/app/services/devices/device.service';
import { DL_DAYS_OF_WEEK } from 'src/app/services/DL/dl-schedule.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
    selector: 'app-modal-scheduler-graphic',
    imports: [CommonModule, FormsModule, NgbTooltipModule, DaysOfWeekSelectorComponent, TranslateModule],
    templateUrl: './modal-scheduler-graphic.component.html',
    styleUrl: './modal-scheduler-graphic.component.scss'
})
export class ModalSchedulerGraphicComponent implements OnInit, AfterViewInit {

  /** Array de programas {id, channel, type, mode, daymask, festive, time} */
  @Input() schedulerData: any[] = [];
  @Input() selectedOutput: number = 1;
  @Input() sunTimes: any  ;
  @Input() deviceData: any;
  @Input() serial: any;
  list : boolean = false

  @ViewChild('editCanvas') editCanvas!: ElementRef<HTMLCanvasElement>;

  private chart: Chart | null = null;


  // Bitmask (Lunes=1, Martes=2, ..., Domingo=64) para coincidir con DaysOfWeekSelector
  selectedDay: number = 1; // Lunes por defecto

  readonly daysOfWeek = DL_DAYS_OF_WEEK;
  private readonly weekdayKeys = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

  isDaySelected(daymask: unknown, dayValue: number): boolean {
    const mask = Number(daymask) || 0;
    return (mask & dayValue) !== 0;
  }

  toggleDay(program: any, dayValue: number): void {
    if (!program) return;
    const mask = Number(program.daymask) || 0;
    program.daymask = (mask ^ dayValue) & 0x7f;
  }

  schedulerTableData: any[] = [];
  dayData: any[] = [];
  chartData: any;

  // Para el highlight de eventos
  highlightedEventTime: string | null = null;
  highlightedEventType: string | null = null;

  // Para el drag de líneas
  isDragging: boolean = false;
  draggedEventIndex: number = -1;
  dragStartX: number = 0;

  constructor(
    public activeModal: NgbActiveModal,
    private _device: DeviceService,
    public _utils: UtilsService,
    private translate: TranslateService,
  ) { }

  private t(key: string, params?: Record<string, unknown>): string {
    return this.translate.instant(key, params);
  }

  getDayLabel(dayIndex: number): string {
    const key = this.weekdayKeys[dayIndex];
    return key ? this.t(key) : '';
  }

  getTypeLabel(type: number): string {
    switch (Number(type)) {
      case 0: return this.t('off');
      case 1: return this.t('on');
      case 2: return this.t('programKind_pulse');
      case 3: return this.t('programKind_cycle');
      default: return String(type);
    }
  }

  getModeLabel(mode: number): string {
    switch (Number(mode)) {
      case 1: return this.t('sunset');
      case 2: return this.t('sunrise');
      case 4: return this.t('programKind_reductionIni');
      case 8: return this.t('programKind_reductionEnd');
      case 16: return this.t('fixedTime');
      default: return String(mode);
    }
  }

  getChannelLabel(channel: number): string {
    if (channel === 1) return 'C1';
    if (channel === 2) return 'C2';
    return this.t('channelBoth');
  }

  getEventTypeLabel(type: 'sunrise' | 'sunset' | 'fixed'): string {
    switch (type) {
      case 'sunrise': return `☀️ ${this.t('sunrise')}`;
      case 'sunset': return `🌙 ${this.t('sunset')}`;
      default: return `🕐 ${this.t('fixedTime')}`;
    }
  }

  formatOffsetMinutes(offset: number): string {
    const sign = offset > 0 ? '+' : '';
    return this.t('durationMinutes', { value: `${sign}${offset}` });
  }

  getFestivePeriodTooltip(period: number): string {
    return this.t('festivePeriodTooltip', { period: period || 0 });
  }

  ngOnInit(): void {
    console.log("sunTinmesData en ngOnInit ", this.sunTimes);
    console.log('Schedule Data en ngOnInit', this.schedulerData);
    this.schedulerData = (this.schedulerData || []).map((item: any) => ({
      ...item,
      // Para input type="time" necesitamos HH:mm (sin negativos).
      // Solo aplica a mode=16 (hora fija). Para el resto dejamos 00:00.
      timeStr: this._utils.getDateFromMinutes(Number(item?.mode) === 16 ? Number(item?.time) || 0 : 0),
    }));

    // getDay(): 0=Domingo..6=Sábado. Convertimos a índice 0=Lunes..6=Domingo
    const Day = new Date().getDay();
    const dayIndex = Day === 0 ? 6 : Day - 1;
    this.selectedDay = this.daysOfWeek[dayIndex]?.value ?? 1;

    this.createTable();
    console.log('tabla de progrmación ', this.schedulerTableData);
    this.dayData = this.filtrarPorDia();
    console.log('ONinit data per day ', this.dayData);
    this.chartData = this.CreateDataForChart();
    console.log('chartData ', this.chartData);
  }



  ngAfterViewInit(): void {
    setTimeout(() => {
      console.log('chartData length:', this.chartData?.length);
      console.log('sum chartData:', (this.chartData || []).reduce((a, b) => a + b, 0));
      console.log('primeros 30:', (this.chartData || []).slice(0, 30));

      this.createChart();
    }, 100);
    console.log('ngAfterViewInit');
  }


  ngOnChanges(): void {
    console.log('ngOnChanges');


  }


  // Para desglosar la tabla de programaciones por dias de la semana
  createTable(): void {
    this.schedulerTableData = [];

    const schedules = this.getSchedulerData();
    if (!schedules || schedules.length === 0) return;

    // dayIndex: 0=Lunes..6=Domingo | bitmask: 1<<dayIndex
    for (let dayIndex = 0; dayIndex < this.daysOfWeek.length; dayIndex++) {
      const dayBit = 1 << dayIndex;

      schedules.forEach((schedule: any) => {
        console.log(' object schedule ', schedule);
        const scheduleDayMask = schedule?.daymask;
        if (!scheduleDayMask || (scheduleDayMask & dayBit) === 0) return;

        const { type, time, offset } = this.mapScheduleToUiEvent(schedule, dayIndex);
        if (!type) return;

        this.schedulerTableData.push({
          dayIndex,
          type,
          time,
          offset,
          action: schedule?.type,
          period: schedule?.festive
        });
      });
    }
  }

  getSchedulerData(): any[] {
    // Importante: este modal edita UNA salida a la vez.
    // Para poder “mantener la parte del canal no editado” al guardar,
    // aquí devolvemos solo los programas del canal seleccionado.
    // (Los programas channel=3 aplican a ambas salidas; no se editan desde este modal.)
    const selected = Number(this.selectedOutput) || 1;
    return (this.schedulerData || []).filter((p: any) => Number(p?.channel) === selected);
  }

  onDaySelected(dayValue: number): void {
    this.selectedDay = dayValue;
    this.dayData = this.filtrarPorDia();
    this.chartData = this.CreateDataForChart();
    this.updateChart();
  }

  filtrarPorDia() {
    return this.schedulerTableData.filter(p => {
      const dayObj = this.daysOfWeek[p.dayIndex];
      return dayObj ? (dayObj.value & this.selectedDay) !== 0 : false;
    });
  }

  /**
   * Obtiene el label del día seleccionado basado en el valor bitmask
   */
  getSelectedDayLabel(): string {
    const dayObj = this.daysOfWeek.find(d => d.value === this.selectedDay);
    return dayObj ? this.getDayLabel(dayObj.index) : '';
  }

  /**
   * Maneja el hover sobre un evento para resaltar su línea vertical en el gráfico
   */
  onEventHover(eventTime: string, eventType: string): void {
    this.highlightedEventTime = eventTime;
    this.highlightedEventType = eventType;
    this.updateChart();
  }

  /**
   * Quita el resaltado cuando el mouse sale del evento
   */
  onEventLeave(): void {
    this.highlightedEventTime = null;
    this.highlightedEventType = null;
    this.updateChart();
  }

  /**
   * Calcula la hora ajustada para mostrar (hora base + offset)
   */
  getAdjustedTime(item: any): string {
    if (!item.time) return '00:00';

    const [hh, mm] = item.time.split(':').map(Number);
    const baseMinutes = hh * 60 + mm;
    const offset = item.offset || 0;
    const adjustedMinutes = baseMinutes + offset;

    // Manejar wrap-around para mantener en 0-1439
    const clampedMinutes = ((adjustedMinutes % 1440) + 1440) % 1440;

    const adjustedHour = Math.floor(clampedMinutes / 60);
    const adjustedMinute = clampedMinutes % 60;

    return `${String(adjustedHour).padStart(2, '0')}:${String(adjustedMinute).padStart(2, '0')}`;
  }

  /**
   * Cambia el tipo de evento desde el dropdown
   */
  changeEventType(item: any, newType: 'sunrise' | 'sunset' | 'fixed'): void {
    if (item.type === newType) return; // Ya es del mismo tipo

    const currentAdjustedTime = this.getAdjustedTime(item);

    if (newType === 'fixed') {
      // Cambiar a hora fija: usar la hora ajustada actual
      item.type = 'fixed';
      item.time = currentAdjustedTime;
      item.offset = 0;
    } else {
      // Cambiar a sunrise o sunset
      const dayObj = this.daysOfWeek.find(d => d.value === this.selectedDay);
      if (dayObj && this.sunTimes && Array.isArray(this.sunTimes)) {
        const targetDayName = dayObj.label.toLowerCase();
        const sunDay = this.sunTimes.find((s: any) =>
          s && s.weekday && s.weekday.toLowerCase() === targetDayName
        );

        if (sunDay) {
          const baseTimeStr = newType === 'sunrise' ? sunDay.sunriseStr : sunDay.sunsetStr;
          if (baseTimeStr) {
            item.type = newType;
            item.time = baseTimeStr;

            // Calcular offset para mantener la misma hora ajustada
            const [baseHh, baseMm] = baseTimeStr.split(':').map(Number);
            const baseMinute = baseHh * 60 + baseMm;
            const [adjHh, adjMm] = currentAdjustedTime.split(':').map(Number);
            const adjMinute = adjHh * 60 + adjMm;
            item.offset = adjMinute - baseMinute;
          }
        }
      }
    }

    // Reordenar eventos por tiempo ajustado para asegurar orden correcto
    this.dayData.sort((a: any, b: any) => {
      const [aHh, aMm] = a.time.split(':').map(Number);
      const [bHh, bMm] = b.time.split(':').map(Number);
      const aMinute = aHh * 60 + aMm + (a.offset || 0);
      const bMinute = bHh * 60 + bMm + (b.offset || 0);
      return aMinute - bMinute;
    });

    // Regenerar datos del gráfico y actualizar con redibujado completo
    this.chartData = this.CreateDataForChart();
    if (this.chart) {
      this.chart.data.datasets[0].data = this.chartData ?? [];
      this.chart.update('active'); // Forzar redibujado completo de plugins
    }
  }

  /**
   * Cambia la acción del evento entre ON (1) y OFF (0)
   */
  toggleAction(item: any): void {
    // Cambiar entre 1 (ON) y 0 (OFF)
    item.action = item.action === 1 ? 0 : 1;

    // Regenerar datos del gráfico y actualizar con redibujado completo
    this.chartData = this.CreateDataForChart();
    if (this.chart) {
      this.chart.data.datasets[0].data = this.chartData ?? [];
      this.chart.update('active'); // Forzar redibujado completo
    }
  }

  // Adapta la progrmación del días seleccionado para el gráfico (precisión por minutos)
  // Supone que en la clase tienes:
  // this.dayData = [{ day, type, time: 'HH:MM', offset, action: 'on'|'off' }, ...];

  CreateDataForChart() {
    const MINUTES = 1440;

    const toMinutes = (hhmm: string) => {
      const [hh, mm] = (hhmm || '00:00').split(':').map(Number);
      return Math.max(0, Math.min(MINUTES - 1, (hh || 0) * 60 + (mm || 0)));
    };

    const toOnOff = (a: any): 0 | 1 => {
      // Los datos ya vienen como 1 o 0
      return a === 1 ? 1 : 0;
    };

    const events = (this.dayData || [])
      .map(e => {
        // Los datos ya vienen con las horas reales de orto/ocaso desde data.ts
        const base = toMinutes(e.time);
        const minute = Math.max(0, Math.min(MINUTES - 1, base + (e.offset || 0)));
        const value = toOnOff(e.action);
        return { minute, value };
      })
      .sort((a, b) => a.minute - b.minute);

    const data = new Array(MINUTES).fill(0);
    // Inicializar el estado actual teniendo en cuenta el estado final del día anterior
    let current = this.getInitialDayState();
    let j = 0;

    for (let i = 0; i < MINUTES; i++) {
      // Apply any events that occur at or before this minute (robust if offsets push earlier)
      while (j < events.length && events[j].minute <= i) {
        current = events[j].value; // última orden aplicada
        j++;
      }
      data[i] = current;
    }

    return data;
  }

  /**
   * Devuelve 0 o 1 según el estado final de la salida en el día anterior al `selectedDay`.
   * Revisa `this.schedulerData` para la salida seleccionada y considera tipos sunrise/sunset usando `this.sunTimes` si está disponible.
   */
  private getInitialDayState(): 0 | 1 {
    const schedules = this.getSchedulerData();
    if (!schedules || schedules.length === 0) return 0;

    // selectedDay es un bitmask (1,2,4..64). Convertir a dayIndex 0..6
    const dayObj = this.daysOfWeek.find(d => d.value === this.selectedDay);
    const dayIndex = dayObj ? dayObj.index : 0;
    const previousDayIndex = dayIndex === 0 ? 6 : dayIndex - 1;
    const previousDayBit = 1 << previousDayIndex;

    const toMinutes = (hhmm: string) => {
      const [hh, mm] = (hhmm || '00:00').split(':').map(Number);
      return Math.max(0, Math.min(1439, (hh || 0) * 60 + (mm || 0)));
    };

    const prevEvents: { minute: number; value: 0 | 1 }[] = [];

    schedules.forEach((schedule: any) => {
      const scheduleDayMask = schedule?.daymask;
      if (!scheduleDayMask || (scheduleDayMask & previousDayBit) === 0) return;

      // Construir el evento ya normalizado (incluye hora base y offset)
      const uiEvent = this.mapScheduleToUiEvent(schedule, previousDayIndex);
      if (!uiEvent?.type) return;

      const base = toMinutes(uiEvent.time);
      const minute = Math.max(0, Math.min(1439, base + (uiEvent.offset || 0)));
      prevEvents.push({ minute, value: schedule?.type });
    });

    if (prevEvents.length === 0) return 0;
    prevEvents.sort((a, b) => a.minute - b.minute);
    return prevEvents[prevEvents.length - 1].value;
  }


  private minutesToHHMM(minutes: number): string {
    const total = Number.isFinite(minutes) ? minutes : 0;
    const clamped = ((Math.trunc(total) % 1440) + 1440) % 1440;
    const hh = Math.floor(clamped / 60);
    const mm = clamped % 60;
    return `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`;
  }

  /**
   * Convierte un programa {mode,time,type,...} a un evento UI {type,time,offset} para un día concreto.
   * - mode=16 (hora fija): time es minutos 0..1439
   * - mode=2 (orto) / mode=1 (ocaso): time es offset en minutos (-599..599 aprox)
   */
  private mapScheduleToUiEvent(schedule: any, dayIndex: number): { type: 'sunrise' | 'sunset' | 'fixed' | null; time: string; offset: number } {
    const mode = schedule?.mode;
    if (mode === 16) {
      return {
        type: 'fixed',
        time: this.minutesToHHMM(schedule?.time ?? 0),
        offset: 0
      };
    }

    if (mode === 2 || mode === 1) {
      const base = this.getSunTimeForDayIndex(dayIndex, mode === 2 ? 'sunrise' : 'sunset');
      return {
        type: mode === 2 ? 'sunrise' : 'sunset',
        time: base ?? '00:00',
        offset: Number.isFinite(schedule?.time) ? schedule.time : 0
      };
    }

    // Otros modes (4/8...) no se representan en este modal por ahora
    return { type: null, time: '00:00', offset: 0 };
  }

  private getSunTimeForDayIndex(dayIndex: number, type: 'sunrise' | 'sunset'): string | null {
    if (!this.sunTimes || !Array.isArray(this.sunTimes) || this.sunTimes.length === 0) return null;
    const dayLabel = this.daysOfWeek[dayIndex]?.label?.toLowerCase();
    if (!dayLabel) return null;
    const sunDay = this.sunTimes.find((s: any) => s && s.weekday && String(s.weekday).toLowerCase() === dayLabel);
    if (!sunDay) return null;
    return type === 'sunrise' ? (sunDay.sunriseStr ?? null) : (sunDay.sunsetStr ?? null);
  }


  private createChart(): void {
    if (!this.editCanvas) return;

    // (re)destruye por si ya había uno
    this.chart?.destroy();

    const ctx = this.editCanvas.nativeElement.getContext('2d');
    if (!ctx) return;

    const labels = this.buildLabels();

    // Ensure data length matches labels length (labels = 1440)
    if (!this.chartData) this.chartData = [];
    if (this.chartData.length !== labels.length) {
      console.warn('chartData length mismatch with labels:', this.chartData.length, labels.length);
      // pad or truncate
      if (this.chartData.length < labels.length) {
        this.chartData = this.chartData.concat(new Array(labels.length - this.chartData.length).fill(0));
      } else {
        this.chartData = this.chartData.slice(0, labels.length);
      }
    }

    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels,
        datasets: [{
          data: this.chartData,      // array de 1440 con 0/1
          stepped: true,
          fill: false,               // evita relleno que podría tapar el trazo
          borderWidth: 3,            // más visible
          pointRadius: 0,
          borderColor: '#4f81bd',    // color contrastado (verde)
          spanGaps: true,            // por si hubiera undefined (no debería, pero ayuda)
        }]
      },
      options: {
        animation: false,
        // parsing:false removed so Chart.js will handle numeric arrays normally
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          // Forzar rango explícito a 0 y 1 (sin padding extra)
          y: { min: 0, max: 1, ticks: { stepSize: 1, callback: (v) => (v === 1 ? this.t('on') : v === 0 ? this.t('off') : '') } },
          x: { ticks: { autoSkip: true, maxTicksLimit: 24 } }
        },
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: { label: (ctx) => (ctx.parsed.y ? this.t('switched_on') : this.t('switched_off')) }
          }
        },
        elements: {
          line: {
            // asegura que no haya suavizado que "aplane" microtramos
            tension: 0
          }
        }
      },
      plugins: [{
        id: 'nightBackgroundModal',
        beforeDraw: (chart: any) => {
          if (!this.sunTimes || !Array.isArray(this.sunTimes) || this.sunTimes.length === 0) {
            return;
          }

          const ctx = chart.ctx;
          const chartArea = chart.chartArea;
          const xScale = chart.scales.x;

          // Buscar los datos del día seleccionado
          const dayObj = this.daysOfWeek.find(d => d.value === this.selectedDay);
          if (!dayObj) return;

          const targetDayName = dayObj.label.toLowerCase();
          const sunDay = this.sunTimes.find((s: any) =>
            s && s.weekday && s.weekday.toLowerCase() === targetDayName
          );

          if (!sunDay || !sunDay.sunriseStr || !sunDay.sunsetStr) return;

          // Parsear horas de orto y ocaso
          const parseTime = (timeStr: string) => {
            const [hh, mm] = (timeStr || '00:00').split(':').map(Number);
            return (hh || 0) * 60 + (mm || 0);
          };

          const sunriseMinute = parseTime(sunDay.sunriseStr);
          const sunsetMinute = parseTime(sunDay.sunsetStr);

          ctx.save();
          ctx.fillStyle = 'rgba(103, 58, 183, 0.06)'; // Morado/violeta sutil

          // Pintar desde medianoche (0) hasta el orto
          const ortoX = xScale.getPixelForValue(sunriseMinute);
          ctx.fillRect(chartArea.left, chartArea.top, ortoX - chartArea.left, chartArea.bottom - chartArea.top);

          // Pintar desde el ocaso hasta el final del día (1439)
          const ocasoX = xScale.getPixelForValue(sunsetMinute);
          ctx.fillRect(ocasoX, chartArea.top, chartArea.right - ocasoX, chartArea.bottom - chartArea.top);

          ctx.restore();
        }
      }, {
        id: 'ortoOcasoLinesModal',
        afterDraw: (chart: any) => {
          const ctx = chart.ctx;
          const chartArea = chart.chartArea;
          const xScale = chart.scales.x;

          // Dibujar línea destacada si hay un evento en hover
          if (this.highlightedEventTime && this.highlightedEventType) {
            const parseTime = (timeStr: string) => {
              const [hh, mm] = (timeStr || '00:00').split(':').map(Number);
              return { hour: hh || 0, minute: mm || 0 };
            };

            const time = parseTime(this.highlightedEventTime);
            const minuteIndex = time.hour * 60 + time.minute;
            const x = xScale.getPixelForValue(minuteIndex);

            // Determinar color según el tipo de evento
            let highlightColor = '#4f81bd'; // default
            if (this.highlightedEventType === 'sunrise') {
              highlightColor = '#ff9800'; // naranja (text-warning)
            } else if (this.highlightedEventType === 'sunset') {
              highlightColor = '#2e8eaa'; // azul verdoso
            } else if (this.highlightedEventType === 'fixed') {
              highlightColor = '#0d6efd'; // azul (border-primary de Bootstrap 5)
            }

            ctx.save();

            // Línea vertical resaltada con el color del tipo de evento
            ctx.strokeStyle = highlightColor;
            ctx.lineWidth = 8; // Más gruesa para resaltar
            ctx.setLineDash([]);
            ctx.globalAlpha = 0.8;
            ctx.beginPath();
            ctx.moveTo(x, chartArea.top);
            ctx.lineTo(x, chartArea.bottom);
            ctx.stroke();
            ctx.restore();
          }

          if (!this.sunTimes || !Array.isArray(this.sunTimes) || this.sunTimes.length === 0) {
            return; // No hay datos de orto/ocaso
          }

          // Buscar los datos del día seleccionado
          const dayObj = this.daysOfWeek.find(d => d.value === this.selectedDay);
          if (!dayObj) return;

          const targetDayName = dayObj.label.toLowerCase();
          const sunDay = this.sunTimes.find((s: any) => {
            return s && s.weekday && s.weekday.toLowerCase() === targetDayName;
          });

          if (!sunDay || !sunDay.sunriseStr || !sunDay.sunsetStr) return;

          // Parsear las horas de orto y ocaso
          const parseTime = (timeStr: string) => {
            const [hh, mm] = (timeStr || '00:00').split(':').map(Number);
            return { hour: hh || 0, minute: mm || 0 };
          };

          const ortoTime = parseTime(sunDay.sunriseStr);
          const ocasoTime = parseTime(sunDay.sunsetStr);

          // Calcular índices en el array de 1440 minutos
          const ortoIndex = ortoTime.hour * 60 + ortoTime.minute;
          const ocasoIndex = ocasoTime.hour * 60 + ocasoTime.minute;

          // Obtener posiciones X en el gráfico
          const ortoX = xScale.getPixelForValue(ortoIndex);
          const ocasoX = xScale.getPixelForValue(ocasoIndex);

          ctx.save();
          ctx.lineWidth = 2;
          ctx.setLineDash([5, 5]); // Línea discontinua

          // Línea de orto (naranja)
          ctx.strokeStyle = 'rgba(255, 152, 0, 0.8)';
          ctx.beginPath();
          ctx.moveTo(ortoX, chartArea.top);
          ctx.lineTo(ortoX, chartArea.bottom);
          ctx.stroke();

          // Línea de ocaso (azul oscuro/gris)
          ctx.strokeStyle = 'rgba(108, 117, 125, 0.8)';
          ctx.beginPath();
          ctx.moveTo(ocasoX, chartArea.top);
          ctx.lineTo(ocasoX, chartArea.bottom);
          ctx.stroke();

          // Resetear línea discontinua
          ctx.setLineDash([]);

          // Añadir etiquetas encima de las líneas
          const labelY = chartArea.top + 20; // Más abajo desde el borde superior
          ctx.font = 'bold 12px sans-serif';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';

          // Función para dibujar etiqueta con fondo
          const drawLabel = (text: string, x: number, bgColor: string, textColor: string) => {
            const padding = 4;
            const metrics = ctx.measureText(text);
            const width = metrics.width + padding * 2;
            const height = 16;

            // Fondo redondeado
            ctx.fillStyle = bgColor;
            ctx.beginPath();
            ctx.roundRect(x - width / 2, labelY - height / 2, width, height, 3);
            ctx.fill();

            // Texto
            ctx.fillStyle = textColor;
            ctx.fillText(text, x, labelY);
          };

          // Etiqueta de orto
          drawLabel(`☀️ ${sunDay.sunriseStr}`, ortoX, 'rgba(255, 152, 0, 0.9)', '#fff');

          // Etiqueta de ocaso
          drawLabel(`🌙 ${sunDay.sunsetStr}`, ocasoX, 'rgba(108, 117, 125, 0.9)', '#fff');

          ctx.restore();
        }
      }]
    });

    // por si el modal ajusta tamaño justo al abrir
    this.chart.resize();

    // Agregar event listeners para drag
    this.setupDragListeners();
  }

  /**
   * Configura los event listeners para arrastrar líneas verticales
   */
  private setupDragListeners(): void {
    const canvas = this.editCanvas?.nativeElement;
    if (!canvas) return;

    canvas.addEventListener('mousedown', this.onCanvasMouseDown.bind(this));
    canvas.addEventListener('mousemove', this.onCanvasMouseMove.bind(this));
    canvas.addEventListener('mouseup', this.onCanvasMouseUp.bind(this));
    canvas.addEventListener('mouseleave', this.onCanvasMouseUp.bind(this));

    // Cambiar cursor cuando está sobre una línea arrastrable
    canvas.style.cursor = 'default';
  }

  /**
   * Detecta si el click está cerca de una línea vertical de evento
   */
  private onCanvasMouseDown(event: MouseEvent): void {
    if (!this.chart || !this.dayData) return;

    const rect = this.editCanvas.nativeElement.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const xScale = this.chart.scales['x'];

    // Tolerancia de 5px para detectar la línea
    const tolerance = 5;

    // Buscar si hay una línea cerca del click
    for (let i = 0; i < this.dayData.length; i++) {
      const event = this.dayData[i];
      const [hh, mm] = event.time.split(':').map(Number);
      const baseMinute = hh * 60 + mm;
      // Aplicar offset para obtener la posición real de la línea
      const minuteIndex = baseMinute + (event.offset || 0);
      const lineX = xScale.getPixelForValue(minuteIndex);

      if (Math.abs(x - lineX) <= tolerance) {
        this.isDragging = true;
        this.draggedEventIndex = i;
        this.dragStartX = x;
        this.editCanvas.nativeElement.style.cursor = 'ew-resize';
        break;
      }
    }
  }

  /**
   * Mueve la línea mientras se arrastra
   */
  private onCanvasMouseMove(event: MouseEvent): void {
    if (!this.chart || !this.dayData) return;

    const rect = this.editCanvas.nativeElement.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const xScale = this.chart.scales['x'];

    if (this.isDragging && this.draggedEventIndex >= 0) {
      // Calcular nuevo minuto basado en la posición X
      const minuteIndex = Math.round(xScale.getValueForPixel(x) as number);
      const clampedMinute = Math.max(0, Math.min(1439, minuteIndex));

      const draggedEvent = this.dayData[this.draggedEventIndex];

      // Si es orto o ocaso, calcular el offset respecto a la hora astronómica real
      if (draggedEvent.type === 'sunrise' || draggedEvent.type === 'sunset') {
        // Obtener la hora astronómica real para este día
        const dayObj = this.daysOfWeek.find(d => d.value === this.selectedDay);
        if (dayObj && this.sunTimes && Array.isArray(this.sunTimes)) {
          const targetDayName = dayObj.label.toLowerCase();
          const sunDay = this.sunTimes.find((s: any) =>
            s && s.weekday && s.weekday.toLowerCase() === targetDayName
          );

          if (sunDay) {
            // Obtener la hora astronómica base
            const baseTimeStr = draggedEvent.type === 'sunrise' ? sunDay.sunriseStr : sunDay.sunsetStr;
            if (baseTimeStr) {
              const [baseHh, baseMm] = baseTimeStr.split(':').map(Number);
              const baseMinute = baseHh * 60 + baseMm;

              // Calcular el offset en minutos
              const newOffset = clampedMinute - baseMinute;
              draggedEvent.offset = newOffset;

              // Actualizar el tiempo a la hora astronómica base (el offset se aplica en CreateDataForChart)
              draggedEvent.time = baseTimeStr;
            }
          }
        }
      } else {
        // Para eventos fixed, actualizar directamente el tiempo
        const newHour = Math.floor(clampedMinute / 60);
        const newMinute = clampedMinute % 60;
        const newTime = `${String(newHour).padStart(2, '0')}:${String(newMinute).padStart(2, '0')}`;
        draggedEvent.time = newTime;
        draggedEvent.offset = 0; // Los eventos fixed no tienen offset
      }

      // Regenerar datos del gráfico y actualizar
      this.chartData = this.CreateDataForChart();
      this.updateChart();
    } else {
      // Cambiar cursor si está sobre una línea
      const tolerance = 5;
      let overLine = false;

      for (let i = 0; i < this.dayData.length; i++) {
        const event = this.dayData[i];
        const [hh, mm] = event.time.split(':').map(Number);
        const baseMinute = hh * 60 + mm;
        // Aplicar offset para obtener la posición real de la línea
        const minuteIndex = baseMinute + (event.offset || 0);
        const lineX = xScale.getPixelForValue(minuteIndex);

        if (Math.abs(x - lineX) <= tolerance) {
          overLine = true;
          break;
        }
      }

      this.editCanvas.nativeElement.style.cursor = overLine ? 'ew-resize' : 'default';
    }
  }

  /**
   * Finaliza el arrastre
   */
  private onCanvasMouseUp(event: MouseEvent): void {
    if (this.isDragging && this.draggedEventIndex >= 0) {
      // Aquí puedes agregar lógica para guardar los cambios en schedulerData
      console.log('Evento actualizado:', this.dayData[this.draggedEventIndex]);
    }

    this.isDragging = false;
    this.draggedEventIndex = -1;
    this.editCanvas.nativeElement.style.cursor = 'default';
  }


  buildLabels(): string[] {
    const MINUTES = 1440;
    return Array.from({ length: MINUTES }, (_, i) => {
      const h = String(Math.floor(i / 60)).padStart(2, '0');
      const m = String(i % 60).padStart(2, '0');
      return `${h}:${m}`;
    });
  }

  updateChart(): void {
    if (!this.chart) return;
    this.chart.data.datasets[0].data = this.chartData ?? [];
    this.chart.update('none'); // sin animación
  }

  addProgram(){
    this.schedulerData.push({
      id: this.schedulerData.length, // temporal, se asignará un ID válido al guardar
      channel: Number(this.selectedOutput) || 1,
      type: 1, // ON por defecto
      mode: 16, // hora fija
      daymask: Number(this.selectedDay) || 1,
      festive: 0,
      time: 0,
    });

  }


  deletePrograman(index: number): void {
    this.dayData.splice(index, 1);
    this.schedulerTableData = this.schedulerTableData.filter(p => {
      const dayObj = this.daysOfWeek[p.dayIndex];
      return dayObj ? (dayObj.value & this.selectedDay) !== 0 : false;
    });
    this.chartData = this.CreateDataForChart();
    this.updateChart();
  }

  closeModal(): void {
    this.activeModal.dismiss();
  }
  saveChanges(): void {
    const selectedChannel = Number(this.selectedOutput) || 1;
    const existing = Array.isArray(this.schedulerData) ? this.schedulerData : [];

    // Reemplazar únicamente el canal editado, preservando el resto (incl. IDs)
    const updatedSelected = this.formatProgramForSaving(this.schedulerTableData);
    const mergedActive = this.mergeByChannelPreservingIds(existing, selectedChannel, updatedSelected);
    this.schedulerData = mergedActive;

    // Construir el body del módulo scheduler: 40 entradas (0..39) con arrays de 10 bytes serializados
    const body = this.buildSchedulerCfgBody(mergedActive);

    const deviceSerial =
      typeof this.serial === 'string' && this.serial.length ? this.serial :
      (typeof this.deviceData === 'string' && this.deviceData.length ? this.deviceData : this.deviceData?.serial);

    if (deviceSerial) {
      this._device.setModuleCfg(deviceSerial, body, 'scheduler').subscribe({
        next: () => {},
        error: (err) => console.error('Error guardando scheduler:', err)
      });
    }

    this.activeModal.close(mergedActive);
  }

  private mergeByChannelPreservingIds(existing: any[], selectedChannel: number, updatedSelected: any[]): any[] {
    const isValidId = (v: any) => Number.isFinite(Number(v)) && Number(v) >= 0 && Number(v) <= 39;

    const preserved = (existing || []).filter((p: any) => Number(p?.channel) !== selectedChannel);
    const existingSelected = (existing || []).filter((p: any) => Number(p?.channel) === selectedChannel);

    const preservedIds = new Set<number>(
      preserved
        .map((p: any) => Number(p?.id))
        .filter((id: number) => isValidId(id))
    );

    const preferredIds = existingSelected
      .map((p: any) => Number(p?.id))
      .filter((id: number) => isValidId(id))
      .sort((a: number, b: number) => a - b);

    const preferredSet = new Set<number>(preferredIds);

    const availableIds: number[] = [];
    for (let i = 0; i < 40; i++) {
      if (!preservedIds.has(i)) availableIds.push(i);
    }

    const idPool = [...preferredIds, ...availableIds.filter((id) => !preferredSet.has(id))];
    const trimmedUpdated = (updatedSelected || []).slice(0, idPool.length);

    const updatedWithIds = trimmedUpdated.map((p: any, idx: number) => ({
      ...p,
      id: idPool[idx],
      channel: selectedChannel,
    }));

    return [...preserved, ...updatedWithIds].filter((p: any) => Number(p?.channel) !== 0);
  }

  private int32ToBytesBE(value: number): [number, number, number, number] {
    // Fuerza a int32 (two's complement). Soporta negativos (offsets sunrise/sunset)
    const v = (Number(value) | 0);
    return [
      (v >> 24) & 0xff,
      (v >> 16) & 0xff,
      (v >> 8) & 0xff,
      v & 0xff,
    ];
  }

  private uiDaymaskToDeviceDaymask(mask: unknown): number {
    // UI: bit0=lunes..bit6=domingo -> Dispositivo: bit6=lunes..bit0=domingo
    const m = (Number(mask) || 0) & 0x7f;
    let out = 0;
    for (let i = 0; i < 7; i++) {
      if ((m & (1 << i)) !== 0) out |= (1 << (6 - i));
    }
    return out;
  }

  private buildSchedulerCfgBody(programs: any[]): Record<string, string> {
    // Relleno por defecto (slot vacío) para limpiar entradas antiguas
    const slots: any[] = Array.from({ length: 40 }, (_, id) => ({
      id,
      channel: 0,
      type: 0,
      mode: 0,
      daymask: 0,
      festive: 0,
      time: 0,
    }));

    (programs || []).forEach((p: any) => {
      const id = Number(p?.id);
      if (!Number.isFinite(id) || id < 0 || id > 39) return;
      slots[id] = {
        id,
        channel: Number(p?.channel) || 0,
        type: Number(p?.type) || 0,
        mode: Number(p?.mode) || 0,
        daymask: this.uiDaymaskToDeviceDaymask(p?.daymask),
        festive: Number(p?.festive) || 0,
        time: Number(p?.time) || 0,
      };
    });

    const body: Record<string, string> = {};

    slots.forEach((p: any) => {
      const [b0, b1, b2, b3] = this.int32ToBytesBE(p.time);
      const arr = [
        b0,
        b1,
        b2,
        b3,
        (Number(p.id) & 0xff),
        (Number(p.channel) & 0xff),
        (Number(p.type) & 0xff),
        (Number(p.mode) & 0xff),
        (Number(p.daymask) & 0xff),
        (Number(p.festive) & 0xff),
      ];

      body[String(p.id)] = JSON.stringify(arr);
    });

    return body;
  }


  /**
   * Convierte `schedulerTableData` (UI) a `schedulerData` (formato ANC).
   * - fixed  -> mode=16, time=minutos (0..1439)
   * - sunrise-> mode=2,  time=offset (minutos)
   * - sunset -> mode=1,  time=offset (minutos)
   * Agrupa por (channel,type,mode,time,festive) y combina daymask.
   */
  formatProgramForSaving(table: any[] = this.schedulerTableData): any[] {
    const hhmmToMinutes = (hhmm: string): number => {
      const [hh, mm] = String(hhmm || '00:00').split(':').map((v) => Number(v));
      const minutes = (Number.isFinite(hh) ? hh : 0) * 60 + (Number.isFinite(mm) ? mm : 0);
      return Math.max(0, Math.min(1439, minutes));
    };

    const dayLabelToBit = (dayIndex: number): number => {
      return dayIndex >= 0 && dayIndex < this.daysOfWeek.length ? (1 << dayIndex) : 0;
    };

    const map = new Map<string, any>();

    (table || []).forEach((row: any) => {
      if (!row) return;

      const dayBit = dayLabelToBit(Number(row.dayIndex));
      if (!dayBit) return;

      const uiType = row.type as 'sunrise' | 'sunset' | 'fixed' | string;
      const action = Number(row.action) || 0;
      const festive = Number(row.period) || 0;
      const offset = Number(row.offset) || 0;

      let mode: number;
      let time: number;

      if (uiType === 'fixed') {
        mode = 16;
        time = hhmmToMinutes(row.time);
      } else if (uiType === 'sunrise') {
        mode = 2;
        time = offset;
      } else if (uiType === 'sunset') {
        mode = 1;
        time = offset;
      } else {
        return;
      }

      const channel = Number(this.selectedOutput) || 1;

      const key = `${channel}|${action}|${mode}|${time}|${festive}`;
      const existing = map.get(key);

      if (existing) {
        existing.daymask = (Number(existing.daymask) || 0) | dayBit;
      } else {
        map.set(key, {
          id: 0, // se asigna al final
          channel,
          type: action,
          mode,
          daymask: dayBit,
          festive,
          time,
        });
      }
    });

    const programs = Array.from(map.values())
      .sort((a, b) => {
        // orden estable: por festive, daymask, mode, time
        const af = Number(a.festive) || 0;
        const bf = Number(b.festive) || 0;
        if (af !== bf) return af - bf;
        const adm = Number(a.daymask) || 0;
        const bdm = Number(b.daymask) || 0;
        if (adm !== bdm) return adm - bdm;
        const am = Number(a.mode) || 0;
        const bm = Number(b.mode) || 0;
        if (am !== bm) return am - bm;
        return (Number(a.time) || 0) - (Number(b.time) || 0);
      })
      .slice(0, 40);

    programs.forEach((p, i) => (p.id = i));
    return programs;
  }

  // Alias por compatibilidad con el nombre anterior (typo)
  fortmatProgramForSaving(table: any[] = this.schedulerTableData): any[] {
    return this.formatProgramForSaving(table);
  }

}
